<template>
  <div>
    <h4>Order Pending Admin Review</h4>
    <p>
      Assigned To: {{ order.assignment.name }} ({{ order.assignment.email }})
    </p>
    <p>Assigned On: {{ order.assignment.date }}</p>
    <p>
      Expected Delivery: {{ order.assignment.expected }} ({{
        order.assignment.hours
      }}
      Hours)
    </p>
    <p>Submitted On: {{ order.assignment.completed_at }}</p>
    <p>Writer Pay: KES {{ order.assignment.payment }}</p>
    <p>
      Document:
      <a
        :href="order.assignment.document"
        target="_blank"
        class="btn btn-link ms-2"
        ><i class="fal fa-download"></i>Download</a
      >
    </p>
    <h5>Actions</h5>
    <div>
      <a href="#" class="btn btn-primary" @click.prevent="approve"
        ><i class="fal fa-check"></i>Send To Customer For Review</a
      >
      <a
        href="#"
        class="btn btn-warning float-end"
        @click.prevent="show_box = true"
        ><i class="fal fa-redo"></i>Return to writer for changes</a
      >
    </div>

    <modal :show="show_box" @close="show_box = false">
      <template slot="header">Return to writer for changes</template>
      <form @submit.prevent="submit" id="return-form">
        <div class="mb-3">
          <label>Message</label>
          <textarea
            name="message"
            v-model="message"
            placeholder="Message"
            rows="4"
            class="form-control"
          ></textarea>
        </div>
        <div class="mb-3">
          <label>Penalty in KES <small>Will be deducted from writer payment</small></label>
          <input type="number" v-model="penalty" placeholder="Penalty" class="form-control">
        </div>
        <div class="mb-3">
          <button class="btn btn-primary">
            <i class="fa fa-save"></i>Proceed
          </button>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show_box: false,
      message: null,
      penalty: 0
    };
  },

  props: ["order"],

  methods: {
    submit() {
      let data = {
        form_id: "return-form",
        message: this.message,
        penalty: this.penalty,
        action: "return-writer",
      };

      this.$axios
        .put(`/api/v1/admin/orders/${this.$route.params.id}`, data)
        .then(() => {
          this.show_box = false;
          this.$emit("success");
        });
    },

    approve() {
      let data = {
        action: "approve",
      };

      this.$axios
        .put(`/api/v1/admin/orders/${this.$route.params.id}`, data)
        .then(() => {
          this.$emit("success");
        });
    },
  },
};
</script>
